import { FileText, Share2, CircleCheck } from "lucide-react";

const EXTRAS = [
  {
    key: "brand-guide",
    icon: FileText,
    tag: "1-page PDF",
    title: "Brand guidelines",
    desc: "A ready-to-share brand sheet built from your logo, in seconds.",
    points: [
      "AI-matched Google Fonts for headings & body",
      "Colours with HEX, RGB and CMYK",
      "Clear-space guide, light & dark versions",
      "Do's & don'ts drawn from your actual logo",
    ],
  },
  {
    key: "social-kit",
    icon: Share2,
    tag: "17 files",
    title: "Social kit",
    desc: "Every size you need to launch, on your brand colour.",
    points: [
      "Profile pictures for Instagram, Facebook, LinkedIn, X, TikTok, YouTube",
      "Cover banners incl. YouTube channel art",
      "Favicons 16–512px + favicon.ico",
      "Wide logos use just the symbol so icons stay sharp",
    ],
  },
];

export const BrandExtrasSection = () => (
  <section className="border-b border-black/5 bg-[#F8F9FA]" data-testid="brand-extras-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-28">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12">
        <div className="md:col-span-5">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-[#52525B] mb-3">03 — Beyond the vector</div>
          <h2 className="text-3xl md:text-4xl tracking-tight font-bold leading-tight">
            Your whole brand kit,<br />
            <span className="text-[#ED5A24]">from one blurry file.</span>
          </h2>
        </div>
        <div className="md:col-span-7 md:pt-8">
          <p className="text-base text-[#52525B] leading-relaxed">
            Once your logo is vectorised, one click turns it into a brand guidelines sheet and a full
            social media pack. Both are also included in every download bundle.
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-black/10 border border-black/10">
        {EXTRAS.map(({ key, ...x }) => <ExtraCard key={key} {...x} />)}
      </div>
    </div>
  </section>
);

const ExtraCard = ({ icon: Icon, tag, title, desc, points }) => (
  <div className="bg-white p-8 md:p-10 transition-transform duration-200 hover:-translate-y-1" data-testid={`extra-card-${title.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="flex items-center justify-between mb-8">
      <Icon className="w-6 h-6 text-[#ED5A24]" strokeWidth={2} />
      <span className="text-[10px] uppercase tracking-[0.25em] font-bold bg-[#0A0A0B] text-white px-2.5 py-1">{tag}</span>
    </div>
    <h3 className="text-2xl font-bold tracking-tight mb-2">{title}</h3>
    <p className="text-sm text-[#52525B] leading-relaxed mb-6">{desc}</p>
    <ul className="space-y-2.5">
      {points.map((p) => (
        <li key={p} className="flex items-start gap-3 text-sm">
          <CircleCheck className="w-4 h-4 text-[#ED5A24] mt-0.5 shrink-0" strokeWidth={2.5} />
          <span>{p}</span>
        </li>
      ))}
    </ul>
  </div>
);
